<template>
  <div
    class="image-viewer"
    @mouseover="showIcon"
    @mouseleave="hideIcon"
    @click="showViewer"
  >
    <img :src="src" alt="图片" ref="image" />
    <i class="view-icon fa fa-eye"></i>
  </div>
</template>

<script>
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";

export default {
  props: {
    src: String,
    alt: String,
  },
  data() {
    return {
      viewerInstance: null, // 记录 Viewer.js 实例
    };
  },
  methods: {
    showViewer() {
      // 如果之前已经存在 Viewer 实例，则先销毁之前的实例
      if (this.viewerInstance) {
        this.viewerInstance.destroy();
        this.viewerInstance = null;
      }
      // 创建新的 Viewer 实例并显示
      this.viewerInstance = new Viewer(this.$refs.image, {
        title: this.alt,
        zIndex: 9999,
        toolbar: false,
      });
      this.viewerInstance.show();
    },
    showIcon() {
      // 显示查看图标
      const icon = this.$el.querySelector(".view-icon");
      if (icon) {
        icon.style.display = "block";
      }
    },
    hideIcon() {
      // 隐藏查看图标
      const icon = this.$el.querySelector(".view-icon");
      if (icon) {
        icon.style.display = "none";
      }
    },
    beforeDestroy() {
      // 在组件销毁前销毁 Viewer 实例
      if (this.viewerInstance) {
        this.viewerInstance.destroy();
        this.viewerInstance = null;
      }
    },
  },
};
</script>

<style scoped>
.image-container {
  position: relative; /* 图片容器定位，以便在其中绝对定位图标 */
}
.view-icon {
  cursor: pointer;
  display: none; /* 初始状态隐藏图标 */
  position: absolute;
  top: 50%; /* 将图标居中定位 */
  left: 50%;
  transform: translate(-50%, -50%); /* 将图标居中定位 */
  font-size: 24px;
  color: #fff;
  background-color: rgba(196, 198, 201, 0.6);
  padding: 13.5px 12px;
  /* border-radius: 4px; */
}
/* 可选：为图片增加一些样式，使其居中显示 */
.image-viewer img {
  cursor: pointer;
  width: 50px;
  height: 50px;
  display: block;
  margin: 0 auto;
  max-width: 100%;
}
.fa {
  color: #409eff;
  font-weight: 100; /* 设置字重 */
}
</style>


// WEBPACK FOOTER //
// src/view/dialog/ImageViewer.vue